import type { LiveOrderBy } from '@module/apis/client-side/live/type';

type SearchParamsLike = Pick<URLSearchParams, 'get'>;

/* RT 대응 - 전환 후 삭제 예정 */
export type LiveSortType = 'newbj' | 'hot' | 'new' | 'viewcount' | 'onlyRealTimeYN';

export interface ResolvedLiveSort {
  onlyNewBj: 'Y' | 'N';
  orderBy: LiveOrderBy;
  sortType: LiveSortType;
  onlyRealTimeYN: 'Y' | 'N';
}

type LiveSortRow = Pick<ResolvedLiveSort, 'onlyNewBj' | 'orderBy' | 'onlyRealTimeYN'>;

/* RT 대응 - 전환 후 삭제 예정 */
const LIVE_SORT_BY_TYPE: Record<LiveSortType, LiveSortRow> = {
  onlyRealTimeYN: { onlyNewBj: 'N', orderBy: 'hot', onlyRealTimeYN: 'Y' },
  newbj: { onlyNewBj: 'Y', orderBy: 'user', onlyRealTimeYN: 'N' },
  hot: { onlyNewBj: 'N', orderBy: 'hot', onlyRealTimeYN: 'N' },
  new: { onlyNewBj: 'N', orderBy: 'new', onlyRealTimeYN: 'N' },
  viewcount: { onlyNewBj: 'N', orderBy: 'user', onlyRealTimeYN: 'N' },
};

export function getLiveSortByType(sortType: LiveSortType): ResolvedLiveSort {
  return {
    ...LIVE_SORT_BY_TYPE[sortType],
    sortType,
  };
}

export function getDefaultLiveSortType(defaultOrderBy: LiveOrderBy = 'user'): LiveSortType {
  if (defaultOrderBy === 'hot') return 'hot';
  if (defaultOrderBy === 'new') return 'new';
  // RT 대응 - 전환 후 삭제 예정
  if (defaultOrderBy === 'realtime') return 'onlyRealTimeYN';
  return 'viewcount';
}

export function getResolvedLiveSort(
  searchParams: SearchParamsLike,
  defaultOrderBy: LiveOrderBy = 'user',
): ResolvedLiveSort {
  const onlyNewBj = searchParams.get('onlyNewBj') === 'Y' ? 'Y' : 'N';
  const orderByParam = searchParams.get('orderBy');
  const orderBy: LiveOrderBy =
    orderByParam === 'hot' || orderByParam === 'new' || orderByParam === 'user' ? orderByParam : defaultOrderBy;

  if (onlyNewBj === 'Y' && orderBy === 'user') {
    return getLiveSortByType('newbj');
  }

  // RT 대응 - 전환 후 삭제 예정
  const onlyRealTimeYN = searchParams.get('onlyRealTimeYN') === 'Y' ? 'Y' : 'N';
  if (onlyRealTimeYN === 'Y' && orderBy === 'hot') {
    return getLiveSortByType('onlyRealTimeYN');
  }

  if (onlyNewBj === 'N' && orderBy === 'hot') {
    return getLiveSortByType('hot');
  }

  if (onlyNewBj === 'N' && orderBy === 'new') {
    return getLiveSortByType('new');
  }

  return getLiveSortByType(getDefaultLiveSortType(orderBy));
}
